import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ICreatePlant } from "./interfaces/create-plants.interface";
import { IUpdatePlant } from "./interfaces/update-plants.interface";
import { PlantsService } from "./plants.service";
import PlantsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { MatTabsModule } from "@angular/material/tabs";
import {
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { CompanyService } from "../company/company.service.service";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { getCode } from 'app/utils/method';
import { PlantExport } from "./exports/plant.export";
import { PLANT_TITLE } from "./exports/plant.constants";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';

@Component({
  selector: "app-plant",
  standalone: true,
  templateUrl: "./plant.component.html",
  styleUrl: "./plant.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    PlantExport
  ],
})
export class PlantComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "status", "actions"];
  currentCreatePlant: ICreatePlant = this.initializeCreatePlant();
  currentUpdatePlant: PlantsAttributes | undefined;

  dataSource: PlantsAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  form: FormGroup;
  selectedStatuses: number[] = []; // Activo, Inactivo

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;

  constructor(
    private readonly plantService: PlantsService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private plantExport: PlantExport,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [null],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
    });
  }

  private initializeCreatePlant(): ICreatePlant {
    return { code: "", name: "", companyId: [] };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

   clearFilters(): void {
    this.searchQuery = "";
    this.form.reset({ companyId: null });
    this.findAllWithCount();
  }
  
  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      status: this.selectedStatuses.length > 0 ? this.selectedStatuses : undefined
    };

    this.plantService
      .findAllWithCount({
        currentPage: this.pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof PlantsAttributes {
    const validSortFields: (keyof PlantsAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof PlantsAttributes)
      ? (this.sort.active as keyof PlantsAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: PlantsAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.ensureCompaniesLoaded();
    this.currentCreatePlant = this.initializeCreatePlant();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createPlant());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(plant: PlantsAttributes): void {
    this.ensureCompaniesLoaded();
    this.currentUpdatePlant = {
      ...plant,
      externalKeys: {
        code: plant?.externalKeys?.code ?? null,
      }
    };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updatePlant(plant._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createPlant(): void {
    this.plantService.create(this.currentCreatePlant).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updatePlant(id: string): void {
    if (this.currentUpdatePlant) {
      const updatedPlant: IUpdatePlant = {
        ...this.currentUpdatePlant,
        companyId: this.currentUpdatePlant.company.map((company) => company._id.toString()),
      };

      this.plantService.update(id, updatedPlant).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, plant: PlantsAttributes): void {
    const originalStatusId = plant.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedPlant = { ...plant, statusId: updatedStatusId };

    this.plantService.update(plant._id.toString(), updatedPlant).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        plant.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
      },
    });
  }

  openDeleteDialog(plant: PlantsAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: plant, disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(plant._id.toString()));
  }

  delete(id: string): void {
    this.plantService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  onCompanySelectionChange(companyIds: string[]): void {
    if (this.currentUpdatePlant) {
      this.currentUpdatePlant.company = companyIds.map(
        (companyId) =>
          this.companyList.find((sub) => sub._id.toString() === companyId)!
      );
    }
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  //exportar
  onExportButtonPressed() {
    if (!this.plantExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: PLANT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.plantExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
